import { render, staticRenderFns } from "./BaseTutorImage.vue?vue&type=template&id=2a3c70ba&scoped=true&"
import script from "./BaseTutorImage.vue?vue&type=script&lang=js&"
export * from "./BaseTutorImage.vue?vue&type=script&lang=js&"
import style0 from "./BaseTutorImage.vue?vue&type=style&index=0&id=2a3c70ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c70ba",
  null
  
)

export default component.exports